module.exports = __webpack_public_path__ + "fonts/Gotham-Book.9019ab71.otf";